import type { ComponentProps } from 'react';
import { cn, RadioGroupItem as HeritageRadioGroupItem } from '@herit-fe/heritage-ui';
import { CONTROL_BOX } from './form-control-style';

/**
 * 라디오 아이템 — heritage `RadioGroupItem`(base-ui) 위에 **치수 보강**. 외부 npm 이라 직접 수정
 * 불가 → wrapper 로 className 보강 (`checkbox.tsx` 와 동일 전략).
 *
 * heritage 기본은 16px 인데 `Checkbox` 와 나란히 놓이는 자리(동의·선택 목록)가 있어 치수를 맞춘다
 * (SSOT = `CONTROL_BOX`). 선택 점은 heritage 가 indicator 안에 직접 그려 className 을 못 받으므로,
 * Root 에서 자손 선택자로 크기만 덮어 원래 비율(박스의 50%)을 유지시킨다.
 */
const DOT_CLASS = '[&_[data-slot=radio-group-indicator]>span]:size-3';

export function RadioGroupItem({
  className,
  ...props
}: ComponentProps<typeof HeritageRadioGroupItem>) {
  return <HeritageRadioGroupItem className={cn(CONTROL_BOX, DOT_CLASS, className)} {...props} />;
}
